import React from 'react';
import { Invitation } from '../types/game';
import { NeonButton } from './NeonButton';
import { useSound } from '../hooks/useSound';

interface InvitationModalProps {
  invitation: Invitation | null;
  onAccept: (invitationId: string) => void;
  onReject: (invitationId: string) => void;
}

export const InvitationModal: React.FC<InvitationModalProps> = ({
  invitation,
  onAccept,
  onReject
}) => {
  const { playSound } = useSound();

  if (!invitation) return null;

  const handleAccept = () => {
    playSound('connect');
    onAccept(invitation.id);
  };

  const handleReject = () => {
    playSound('click');
    onReject(invitation.id);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80">
      <div className="ui-card max-w-md w-full animate-pulse-slow">
        <div className="text-center mb-6">
          <div className="text-5xl sm:text-6xl mb-3 sm:mb-4 animate-bounce">🎮</div>
          <h2 className="font-retro text-neon-cyan text-xl sm:text-2xl mb-2">
            ¡INVITACIÓN RECIBIDA!
          </h2>
          <div className="font-retro text-neon-yellow text-base sm:text-lg">
            {invitation.from.name}
          </div>
          <div className="font-retro text-gray-400 text-xs sm:text-sm">
            quiere jugar contigo ({invitation.from.symbol} vs TÚ)
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
          <NeonButton
            onClick={handleAccept}
            color="green"
            className="w-full sm:flex-1"
          >
            ACEPTAR
          </NeonButton>
          <NeonButton
            onClick={handleReject}
            color="pink"
            className="w-full sm:flex-1"
          >
            RECHAZAR
          </NeonButton>
        </div>
      </div>
    </div>
  );
};
